//#region ../../packages/constants/event.ts
const UPDATE_MODEL_EVENT = "update:modelValue";
const CHANGE_EVENT = "change";
const INPUT_EVENT = "input";

//#endregion
export { CHANGE_EVENT, INPUT_EVENT, UPDATE_MODEL_EVENT };
//# sourceMappingURL=event.mjs.map